import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Utils} from "../../utils";
import {AccountManagerService} from "../../services/account-manager-service";
import {environment} from "@environments/environment";
import {DEBUG, DebugService} from "../../services/debug.service";
import {SettingsManagerService} from "../../services/settings-manager.service";
import {CookieService} from "ngx-cookie-service";

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {

  isLoggingIn = true;
  email: string = '';
  password: string = '';

  error: boolean;

  constructor(
    private accountManagerService: AccountManagerService,
    public settingsManagerService: SettingsManagerService,
    private debugService: DebugService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private cookieService: CookieService
  ) { }

  ngOnInit(): void {

    // Check if is SSO login or standard login
    if (this.activatedRoute.snapshot.data.sso) {

      // We are on SSO login page
      this.ssoLogin();

    } else {

      // We are on standard login page and check if a previous session was detected
      this.checkLogin();

    }

  }

  async checkLogin() {

    this.debugService.log(DEBUG.LOGIN, 'Checking for previous session...');
    if (this.accountManagerService.account.id && this.accountManagerService.account.id.length > 0) {
      await this.router.navigate(['/']);
      return true;
    } else {
      this.isLoggingIn = false;
      return false;
    }

  }

  async doLogin() {
    this.isLoggingIn = true;
    this.error = false;
    const result = await this.accountManagerService.login(this.email, this.password);
    this.error = !result;
    this.isLoggingIn = false;
  }

  ssoLogin() {
    this.debugService.log(DEBUG.LOGIN, 'SSO login...');

    // Check if we can use cookies to SSO login

    if (this.cookieService.check('access_token') && this.cookieService.check('refresh_token')) {

      // Use cookies for SSO login
      this.debugService.log(DEBUG.LOGIN, 'Using cookies for SSO login...');

      // Get access token and refresh token from cookie
      const accessToken = this.cookieService.get('access_token');
      const refreshToken = this.cookieService.get('refresh_token');

      // If tokens are not set, throw error
      /*if (!accessToken || !refreshToken) {
        this.debugService.error(DEBUG.LOGIN, 'SSO login failed. No tokens found.');
        this.error = true;
        this.isLoggingIn = false;
        return;
      }*/

      // If tokens are set, try to login
      this.accountManagerService.ssoLogin(accessToken, refreshToken).then(async (result) => {
        if (result) {

          this.debugService.log(DEBUG.LOGIN, 'SSO login successful.');
          await this.router.navigate(['/']);

        } else {
          this.debugService.error(DEBUG.LOGIN, 'SSO login failed.');
          this.error = true;
          this.isLoggingIn = false;

        }

        // Clear SSO tokens
        this.clearSSOTokens();

      });

    } else {

      // Use redirect for SSO login
      this.debugService.log(DEBUG.LOGIN, 'No cookies found. Using redirect for SSO login...');

      // Redirect to SSO login
      this.accountManagerService.initSSOLoginFlow();

    }

  }

  clearSSOTokens() {
    this.cookieService.delete('access_token', '/', environment.ssoDomain, false, "Lax");
    this.cookieService.delete('refresh_token', '/', environment.ssoDomain, false, "Lax");
  }

  isValidInput() {
    return this.email.trim().length > 0 && Utils.validateEmail(this.email) && this.password.length >= 6;
  }

  get environment() { return environment }

}
